import { Component } from '@angular/core';
import { SiteSettingsService } from "./service/site-settings.service";
import { ISiteSettings } from './shared/interface/site-settings';
import { NavigationService, INavigationItem, IHeaderItem, IFooterItem, ILanguageItem } from './service/navigation.service';
import { FooterService, IFooterContactInfoItem } from './service/footer.service';
import { TranslateService } from '@ngx-translate/core';
import { DrawerService } from './dynamic-module/lib/drawer/service/drawer.service';
import { RestoreScrollService } from './service/restore-scroll.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  siteSettings: ISiteSettings;
  topNavigation: INavigationItem[];
  headerNavigation: IHeaderItem;
  footerNavigation: IFooterItem;
  footer: IFooterContactInfoItem;

  constructor(
    private siteSettingsService: SiteSettingsService,
    private navigationService: NavigationService,
    private footerService: FooterService,
    private translateService: TranslateService,
    public drawerService: DrawerService,
    private restoreScrollService: RestoreScrollService
  ) {}

  ngOnInit() {
    this.restoreScrollService.watchAndRestore();
    this.translateService.use('');
    this.navigationService.getTopNavigation().subscribe((res) => {
      this.topNavigation = res;
    });
    this.navigationService.getHeaderNavigation().subscribe((res) => {
      this.headerNavigation = res;
    });
    this.navigationService.getFooterNavigation().subscribe((res) => {
      this.footerNavigation = res;
    });
    this.footerService.getFooter().subscribe((res) => {
      this.footer = res;
    });
    this.siteSettingsService.getSiteSettings().then((res) => {
      this.siteSettings = res;
    });
  }
}
